module.exports = __webpack_public_path__ + "img/gp1.358ac37d.png";